import React, { useContext, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import EMPButton from "../../../shared/components/EMPButton/EMPButton";
import { ModalContext } from "../../../shared/components/EMPModal/ModalContext";
import {
  isDualDealer,
  HAS_ONLY_EMP_ONBOARD_ROLE,
  IS_FORD_BRAND,
} from "../../../utils/EmpUtil";

const OnboardingModalHandler = ({
  user,
  canRender,
  handleBrandSwitchModalButtonClick,
}) => {
  const { handleModal, closeModal } = useContext(ModalContext);
  const modalShownRef = useRef(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (
      canRender &&
      user &&
      HAS_ONLY_EMP_ONBOARD_ROLE(user) &&
      isDualDealer(user) &&
      !modalShownRef.current
    ) {
      modalShownRef.current = true;

      const isFord = IS_FORD_BRAND(user.brand);
      const primaryBrand = isFord ? "Ford" : "Lincoln";
      const secondaryBrand = isFord ? "Lincoln" : "Ford";

      const modalContent = (
        <div
          style={{
            padding: "24px 0",
            gap: "32px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              lineHeight: "24px",
              color: "#000000",
              marginBottom: "32px",
            }}
          >
            {t("DealerOnboarding.content.onBoardingHandlerModal.description", {
              primaryBrand: primaryBrand,
              secondaryBrand: secondaryBrand,
            })}
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "16px",
            }}
          >
            <EMPButton
              id={`switch-${secondaryBrand.toLowerCase()}-button`}
              variant="outlined"
              isFord={isFord}
              onClick={() => {
                handleBrandSwitchModalButtonClick?.(
                  `switch-${secondaryBrand.toLowerCase()}-button`,
                  closeModal
                );
              }}
            >
              {t(
                "DealerOnboarding.content.onBoardingHandlerModal.startSecondaryBrandOnboarding",
                { secondaryBrand: secondaryBrand }
              )}
            </EMPButton>
            <EMPButton
              id={`continue-${primaryBrand.toLowerCase()}-button`}
              variant="contained"
              isFord={isFord}
              onClick={() => {
                handleBrandSwitchModalButtonClick?.(
                  `continue-${primaryBrand.toLowerCase()}-button`,
                  closeModal
                );
              }}
            >
              {t(
                "DealerOnboarding.content.onBoardingHandlerModal.continuePrimaryBrandOnboarding",
                { primaryBrand: primaryBrand }
              )}
            </EMPButton>
          </div>
        </div>
      );

      handleModal(
        t("DealerOnboarding.content.onBoardingHandlerModal.title", {
          primaryBrand: primaryBrand,
          secondaryBrand: secondaryBrand,
        }),
        modalContent
      );
    }
  }, [canRender, user, handleModal]);

  return null;
};

OnboardingModalHandler.propTypes = {
  user: PropTypes.object,
  canRender: PropTypes.bool.isRequired,
  handleBrandSwitchModalButtonClick: PropTypes.func,
};

export default OnboardingModalHandler;
